import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";
import { array } from "prop-types";
import { generarEtiquetaPDF, generarEtiquetasPDF } from "../../../../utils/etiquetaQR";
import { generarZPL, qrPayload } from "../../../../utils/etiquetaZPL";
import { imprimirZPL, descargarZPL } from "../../../../utils/zebraPrint";
import { compararTallas } from "../../../../utils/tallas";
import { abrirPDF } from "../../../../utils/abrirPDF";

function ListadoArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  const [telas, setTelas] = useState([]);
  const [habilitacion, setHabilitacion] = useState([]);
  const [is_active, setis_active] = useState("");
  const [codigo, setCodigo] = useState("");
  const [codigoCliente, setCodigoCliente] = useState("");
  const [piezasPrenda, setPiezasPrenda] = useState(1);
  const [codigoSAT, setCodigoSAT] = useState("");
  const [codigoUnidad, setCodigoUnidad] = useState("");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  // 6 listas de precio para el modal de editar
  const [precioA, setPrecioA] = useState(0);
  const [precioB, setPrecioB] = useState(0);
  const [precioC, setPrecioC] = useState(0);
  const [precioD, setPrecioD] = useState(0);
  const [precioE, setPrecioE] = useState(0);
  const [precioF, setPrecioF] = useState(0);
  const [precioG, setPrecioG] = useState(0);
  const [precioH, setPrecioH] = useState(0);
  const [precioI, setPrecioI] = useState(0);
  const [precioJ, setPrecioJ] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  // const [marcas, setMarcas] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamentoEdit, setSelectedDepartamentoEdit] = useState("");
  const [selectedCodigo, setSelectedCodigo] = useState(0);
  const [selectedCodigoCliente, setSelectedCodigoCliente] = useState(0);
  const [selectedNombre, setSelectedNombre] = useState(0);
  // const [selectedMarca, setSelectedMarca] = useState(0);
  const [selectedColeccion, setSelectedColeccion] = useState(0);
  const [selectedDepartamento, setSelectedDepartamento] = useState(0);

  // const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  const [selectedColeccionEdit, setSelectedColeccionEdit] = useState("");
  const [idEditArticulo, setIdEditArticulo] = useState("");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedPatronista, setSelectedPatronista] = useState("");
  const [selectedMuestrista, setSelectedMuestrista] = useState("");
  const [selectedPloter, setSelectedPloter] = useState("");

  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [tallas, setTallas] = useState([]);
  const [selectedTalla, setSelectedTalla] = useState("");
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);
  const [explosionExistentes, setExplosionExistentes] = useState([]);
  const [codigoExplosion, setCodigoExplosion] = useState("");
  const [idExplosion, setIdExplosion] = useState("");
  const [descripcionExplosion, setDescripcionExplosion] = useState("");

  const [idColoresArticulos, setIdColoresArticulos] = useState("");
  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);
  const [coloresOriginales, setColoresOriginales] = useState([]);

  const [idTallasArticulos, setIdTallasArticulos] = useState("");
  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);
  const [tallasOriginales, setTallasOriginales] = useState([]);

  // Etiquetas QR: modal para capturar cantidad por color/talla
  const [modalEtiquetas, setModalEtiquetas] = useState(false);
  const toggleEtiquetas = () => setModalEtiquetas(!modalEtiquetas);
  const [etiquetaArticulo, setEtiquetaArticulo] = useState(null);
  const [etiquetaColor, setEtiquetaColor] = useState("");
  const [etiquetaTalla, setEtiquetaTalla] = useState("");
  const [etiquetaCantidad, setEtiquetaCantidad] = useState(3); // etiquetas a imprimir en Zebra

  const [idCatalogoProcesosArticulos, setIdCatalogoProcesosArticulos] = useState("");
  const [modalCatalogoProcesos, setModalCatalogoProcesos] = useState(false);
  const toggleCatalogoProcesos = () => setModalCatalogoProcesos(!modalCatalogoProcesos);
  const [arrayCatalogoProcesos, setArrayCatalogoProcesos] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);


  const [totalCaptura, setTotalCaptura] = useState(1);
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      fecha: "",
      descripcion: "",
      compradores: "",
      colaboradores: "",
      marcas: "",
      colecciones: "",
      colores: "",
      tallas: "",
      catalogoProcesos: "",
      patronista: "",
      muestrista: "",
      ploter: "",
      clientes: "",
      pedido: "",
      codigo: "",
      codigoCliente: "",
      departamentos: "",
      subDepartamentos: "",
      clases: "",
      subClases: "",
    },
  ]);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(40), (val, index) => index + year);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      cantidad:0
    },
  ]);

  const [inputFieldsHab, setInputFieldsHab] = useState([
    {
      id: uuidv4(),
      idHab: "",
      cantidad:0
    },
  ]);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        // Array para pagination
        let arrayTabla = allArticulos
          .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              codigo: a.codigo,
              codigoCliente: a.codigoCliente,
              piezasPrenda: a.piezasPrenda || 1,
              codigoSAT: a.codigoSAT,
              codigoUnidad: a.codigoUnidad,
              descripcion: a.descripcion,
              // marca: a.marcas[0].name,
              coleccion: a.colecciones && a.colecciones[0] ? a.colecciones[0].name : "",
              // idMarca: a.marcas[0]._id,
              idColeccion: a.colecciones && a.colecciones[0] ? a.colecciones[0]._id : "",
              departamento: a.departamentos && a.departamentos[0] ? a.departamentos[0].name : "",
              idDepartamento: a.departamentos && a.departamentos[0] ? a.departamentos[0]._id : "",
              colores: a.colores,
              tallas : a.tallas,
              catalogoProcesos: a.catalogoProcesos,
              muestrista: a.muestrista && a.muestrista[0] ? a.muestrista[0].nombre + " " + a.muestrista[0].apellido : "",
              idMuestrista: a.muestrista && a.muestrista[0] ? a.muestrista[0]._id : "",
              patronista: a.patronista && a.patronista[0] ? a.patronista[0].nombre + " " + a.patronista[0].apellido : "",
              idPatronista: a.patronista && a.patronista[0] ? a.patronista[0]._id : "",
              ploter: a.ploter && a.ploter[0] ? a.ploter[0].nombre + " " + a.ploter[0].apellido : "",
              idPloter: a.ploter && a.ploter[0] ? a.ploter[0]._id : "",
              precioA: a.precioA,
              precioB: a.precioB,
              precioC: a.precioC,
              precioD: a.precioD,
              precioE: a.precioE,
              precioF: a.precioF,
              precioG: a.precioG,
              precioH: a.precioH,
              precioI: a.precioI,
              precioJ: a.precioJ,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_MARCAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allMarcas = res.data;
    //     setMarcas(allMarcas);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColecciones = res.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setDepartamentos(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelas = res.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allHabilitacion = res.data;
        setHabilitacion(allHabilitacion);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColores = response.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCatalogoProcesos = response.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });
  axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedCodigo == 0 || selectedCodigo == a.codigo) &&
        (selectedCodigoCliente == 0 || selectedCodigoCliente == a.codigoCliente) &&
        // (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        (is_active == 0 || is_active == a.is_active)
      ) {
        return [
          a.codigo,
          a.codigoCliente,
          a.descripcion,
          "$" + new Intl.NumberFormat("en-US").format(a.precioA || 0),
          "$" + new Intl.NumberFormat("en-US").format(a.precioB || 0),
          // a.marca,
          a.coleccion,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 115, 20, 55, 15);
    doc.text("Modelos", 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Codigo Cliente",
          "Descripcion",
          "Precio A",
          "Precio B",
          // "Marca",
          "Coleccion",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    abrirPDF(doc);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedCodigo == 0 || selectedCodigo == a.codigo) &&
        (selectedCodigoCliente == 0 || selectedCodigoCliente == a.codigoCliente) &&
        // (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        (is_active == 0 || is_active == a.is_active)
      ) {
        return {
          // id: a._id,
          Codigo: a.codigo,
          CodigoCliente: a.codigoCliente,
          Descripcion: a.descripcion,
          PrecioA: a.precioA || 0,
          PrecioB: a.precioB || 0,
          // Marca: a.marca,
          Coleccion: a.coleccion,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "Modelos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "Modelos",
        sheetFilter: [
          // "id",
          "Codigo",
          "CodigoCliente",
          "Descripcion",
          "PrecioA",
          "PrecioB",
          // "Marca",
          "Coleccion",
        ],
        sheetHeader: [
          // "id",
          "Codigo",
          "CodigoCliente",
          "Descripcion",
          "PrecioA",
          "PrecioB",
          // "Marca",
          "Coleccion",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedCodigo == 0 || selectedCodigo == a.codigo) &&
        (selectedCodigoCliente == 0 || selectedCodigoCliente == a.codigoCliente) &&
        // (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        (is_active == 0 || is_active == a.is_active)
      ) {
        return [
          a.codigo,
          a.codigoCliente,
          a.descripcion,
          "$" + new Intl.NumberFormat("en-US").format(a.precioA || 0),
          "$" + new Intl.NumberFormat("en-US").format(a.precioB || 0),
          // a.marca,
          a.coleccion,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 115, 20, 55, 15);
    doc.text("Modelos", 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Codigo Cliente",
          "Descripcion",
          "Precio A",
          "Precio B",
          // "Marca",
          "Coleccion",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Modelos",
          email: mailTo,
          fileName: "ListadoModelos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Modelos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    codigo,
    codigoCliente,
    codigoSAT,
    codigoUnidad,
    descripcion,
    observaciones,
    // idMarca,
    idColeccion,
    idEdit,
    idMuestrista,
    idPatronista,
    idPloter,
    pA, pB, pC, pD, pE, pF, pG, pH, pI, pJ,
    idDepto,
    piezas
  ) {
    setCodigo(codigo);
    setCodigoCliente(codigoCliente);
    setCodigoSAT(codigoSAT);
    setCodigoUnidad(codigoUnidad);
    setDescripcion(descripcion);
    setObservaciones(observaciones);
    // setSelectedMarcaEdit(idMarca);
    setSelectedColeccionEdit(idColeccion);
    setIdEditArticulo(idEdit);
    setSelectedMuestrista(idMuestrista)
    setSelectedPatronista(idPatronista)
    setSelectedPloter(idPloter)
    setPrecioA(pA != null ? pA : 0);
    setPrecioB(pB != null ? pB : 0);
    setPrecioC(pC != null ? pC : 0);
    setPrecioD(pD != null ? pD : 0);
    setPrecioE(pE != null ? pE : 0);
    setPrecioF(pF != null ? pF : 0);
    setPrecioG(pG != null ? pG : 0);
    setPrecioH(pH != null ? pH : 0);
    setPrecioI(pI != null ? pI : 0);
    setPrecioJ(pJ != null ? pJ : 0);
    setSelectedDepartamentoEdit(idDepto || "");
    setPiezasPrenda(piezas || 1);
    toggleEdit();
  }

  function editArticulos(event) {
    event.preventDefault();
    // const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticulo}`;
    if (file == null) {
        axios.patch(
          `${URL_ARTICULOS}/${idEditArticulo}`,
          {
            codigo,
            codigoCliente,
            piezasPrenda: Math.max(1, parseInt(piezasPrenda, 10) || 1),
            codigoSAT,
            codigoUnidad,
            descripcion,
            observaciones,
            // marcas: selectedMarcaEdit,
            // Los campos de referencia vacíos se OMITEN: mandar "" revienta el
            // casteo a ObjectId en Mongoose (CastError).
            ...(selectedColeccionEdit ? { colecciones: selectedColeccionEdit } : {}),
            ...(selectedPatronista ? { patronista: selectedPatronista } : {}),
            ...(selectedMuestrista ? { muestrista: selectedMuestrista } : {}),
            ...(selectedPloter ? { ploter: selectedPloter } : {}),
            precioA: parseFloat(precioA) || 0,
            precioB: parseFloat(precioB) || 0,
            precioC: parseFloat(precioC) || 0,
            precioD: parseFloat(precioD) || 0,
            precioE: parseFloat(precioE) || 0,
            precioF: parseFloat(precioF) || 0,
            precioG: parseFloat(precioG) || 0,
            precioH: parseFloat(precioH) || 0,
            precioI: parseFloat(precioI) || 0,
            precioJ: parseFloat(precioJ) || 0,
            ...(selectedDepartamentoEdit ? { departamentos: selectedDepartamentoEdit } : {}),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Articulo",
            detalle: `${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
        });
        console.log(error);
      });
    } else{
        axios.patch(
          `${URL_ARTICULOS}/${idEditArticulo}`,
          {
            codigo,
            codigoCliente,
            piezasPrenda: Math.max(1, parseInt(piezasPrenda, 10) || 1),
            codigoSAT,
            codigoUnidad,
            descripcion,
            observaciones,
            // marcas: selectedMarcaEdit,
            ...(selectedColeccionEdit ? { colecciones: selectedColeccionEdit } : {}),
            precioA: parseFloat(precioA) || 0,
            precioB: parseFloat(precioB) || 0,
            precioC: parseFloat(precioC) || 0,
            precioD: parseFloat(precioD) || 0,
            precioE: parseFloat(precioE) || 0,
            precioF: parseFloat(precioF) || 0,
            precioG: parseFloat(precioG) || 0,
            precioH: parseFloat(precioH) || 0,
            precioI: parseFloat(precioI) || 0,
            precioJ: parseFloat(precioJ) || 0,
            ...(selectedDepartamentoEdit ? { departamentos: selectedDepartamentoEdit } : {}),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("articulo", idEditArticulo);
  
          axios
            .post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then(() => {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Articulo",
                  detalle: `${codigo}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
  
              toggleEdit();
              Swal.fire("Good job!", "Actualizado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
        });
    }
  }

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Codigo Cliente", field: "codigoCliente", sortable: true },
    { name: "Descripcion", field: "descripcion", sortable: true },
    // { name: "Marca", field: "marca", sortable: true },
    { name: "Coleccion", field: "coleccion", sortable: true },
    { name: "Departamento", field: "departamento", sortable: true },
    { name: "Especificacion", field: "especificacion", sortable: false },
    { name: "Diseño", field: "diseno", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigoCliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.descripcion.toLowerCase().includes(search.toLowerCase()) ||
          // comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.coleccion.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    if (selectedCodigoCliente) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    // if (selectedMarca) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idMarca.includes(selectedMarca)
    //   );
    // }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        e.idColeccion.includes(selectedColeccion)
      );
    }
    if (selectedDepartamento) {
      computedComments = computedComments.filter(
        (e) => e.idDepartamento && e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (is_active) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(is_active)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc"  
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" 
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCodigo,
    selectedCodigoCliente,
    // selectedMarca,
    selectedColeccion,
    selectedDepartamento,
    is_active,
  ]);

  function explosion(id, codigo, descripcion){
    setIdExplosion(id)
    setCodigoExplosion(codigo)
    setDescripcionExplosion(descripcion)

    axios
    .get(`${URL_EXPLOSION}Articulo/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allExplosionExistentes = res.data;
      setExplosionExistentes(allExplosionExistentes);
    })
    .catch((err) => {
      console.log(err);
    });

    toggleExplosion()

  }

  const handleRemoveFieldsTelas = (id) => {
    const values = [...inputFieldsTela];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTela(values);
  };

  const handleRemoveFieldsHab = (id) => {
    const values = [...inputFieldsHab];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHab(values);
  };

  const handleAddFieldsTelas = () => {
    setInputFieldsTela([
      ...inputFieldsTela,
      {
        id: uuidv4(),
        idTela: "",
        cantidad:0
      },
    ]);
  };

  const handleAddFieldsHab = () => {
    setInputFieldsHab([
      ...inputFieldsHab,
      {
        id: uuidv4(),
        idHab: "",
        cantidad:0
      },
    ]);
  };

  const handleChangeInputTela = (id, event) => {
    const newInputFieldsTela = inputFieldsTela.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsTela(newInputFieldsTela);
  };

  const handleChangeInputHab = (id, event) => {
    const newInputFieldsHab = inputFieldsHab.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHab(newInputFieldsHab);
  };

  const handleChangeInputExistente = (id, event) => {
    const newExplosionExistentes = explosionExistentes.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setExplosionExistentes(newExplosionExistentes);
  };

function saveExplosion(){
  setValidaBoton(false);
  toggleProgreso();

let totalExplosion = inputFieldsHab.length + inputFieldsTela.length + explosionExistentes.length

  inputFieldsTela.map((a)=>{
    if(a.idTela!="" & a.cantidad > 0){
    axios.post(
      URL_EXPLOSION,
      {
        articulos: idExplosion,
        telas: a.idTela,
        cantidad: a.cantidad,
        tipo: "Tela"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    ).then(()=>{
      totalExplosion = totalExplosion -1
      if(totalExplosion == 0 ){
        axios.post(
          URL_LOGS,
          {
            tipo: "Agregar Explosion",
            detalle: `${idExplosion} ${a.idTela}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
          .then(()=>{
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
      }
    })
  }else{
    totalExplosion = totalExplosion -1
  }
  })

  inputFieldsHab.map((a)=>{
    if(a.idHab!="" & a.cantidad > 0){
    axios.post(
      URL_EXPLOSION,
      {
        articulos: idExplosion,
        habilitacion: a.idHab,
        cantidad: a.cantidad,
        tipo: "Habilitacion"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    ).then(()=>{
      totalExplosion = totalExplosion -1
      if(totalExplosion == 0 ){
        axios.post(
          URL_LOGS,
          {
            tipo: "Agregar Explosion",
            detalle: `${idExplosion} ${a.idHab}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
          .then(()=>{
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
      }
    })
  }else{
    totalExplosion = totalExplosion -1
  }
  })

  explosionExistentes.map((a)=>{
    axios.patch(
      `${URL_EXPLOSION}/${a._id}`,
      {
        cantidad: a.cantidad,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    ).then(()=>{
      totalExplosion = totalExplosion -1
      if(totalExplosion == 0 ){
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Explosion",
            detalle: `${idExplosion}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
          .then(()=>{
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
      }
    })
  })

}

// Abre el modal para elegir un color y una talla y generar UNA etiqueta.
function abrirEtiquetas(a) {
  setEtiquetaArticulo(a);
  // Se puede elegir cualquier color/talla del catálogo (no solo los del artículo).
  setEtiquetaColor(colores && colores[0] ? colores[0].name : "");
  setEtiquetaTalla(tallas && tallas[0] ? tallas[0].name : "");
  toggleEtiquetas();
}

// Piezas que forman la prenda (conjunto de 2 = 2): las etiquetas se imprimen una por pieza
const piezasDe = (a) => Math.max(1, parseInt(a && a.piezasPrenda, 10) || 1);

// Genera la etiqueta con el color y la talla seleccionados (una por cada pieza de la prenda).
function generarEtiquetas() {
  const a = etiquetaArticulo;
  if (!a) return;
  if (!etiquetaColor || !etiquetaTalla) {
    Swal.fire({
      icon: "warning",
      title: "Selecciona color y talla",
      text: "Elige un color y una talla para la etiqueta.",
    });
    return;
  }
  const etiqueta = { codigo: a.codigo, colorName: etiquetaColor, tallaName: etiquetaTalla };
  const piezas = piezasDe(a);
  if (piezas > 1) generarEtiquetasPDF(Array.from({ length: piezas }, (_, i) => ({ ...etiqueta, pieza: i + 1, piezas })));
  else generarEtiquetaPDF(etiqueta);
  toggleEtiquetas();
}

// Imprime en la Zebra GT800 (ZPL, 3-across) la cantidad indicada de etiquetas.
async function imprimirEtiquetasZebra() {
  const a = etiquetaArticulo;
  if (!a) return;
  if (!etiquetaColor || !etiquetaTalla) {
    Swal.fire({ icon: "warning", title: "Selecciona color y talla" });
    return;
  }
  // La cantidad capturada es de PRENDAS; se imprime una etiqueta por pieza
  const prendas = parseInt(etiquetaCantidad, 10) || 0;
  if (prendas <= 0) {
    Swal.fire({ icon: "warning", title: "Captura la cantidad de prendas" });
    return;
  }
  const piezas = piezasDe(a);
  const cant = prendas * piezas;
  // Una entrada por etiqueta; el generador acomoda 3 por fila y rellena la última.
  const registros = Array.from({ length: cant }, (_, i) => ({
    modelo: a.codigo,
    talla: etiquetaTalla,
    color: etiquetaColor,
    pieza: (i % piezas) + 1,
    piezas,
    qr: qrPayload(a.codigo, etiquetaColor, etiquetaTalla),
  }));
  const zpl = generarZPL(registros);
  try {
    // Trabajos grandes van por lotes: se avisa el avance para que no parezca colgado
    Swal.fire({
      title: "Imprimiendo etiquetas",
      html: `Enviando ${cant} etiqueta(s) a la Zebra...`,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
    await imprimirZPL(zpl, (lote, total) => {
      const cont = Swal.getHtmlContainer();
      if (cont) cont.innerHTML = `Enviando ${cant} etiqueta(s)...<br/>Lote ${lote} de ${total}`;
    });
    Swal.fire("Listo", `Enviadas ${cant} etiqueta(s) a la Zebra`, "success");
    toggleEtiquetas();
  } catch (e) {
    // Sin agente/impresora: ofrecer descargar el .zpl
    Swal.fire({
      icon: "warning",
      title: "No se pudo imprimir directo",
      text: "No se encontró Zebra Browser Print. ¿Descargar el archivo .zpl para mandarlo a la impresora?",
      showCancelButton: true,
      confirmButtonText: "Descargar .zpl",
    }).then((r) => {
      if (r.isConfirmed) descargarZPL(zpl, `etiquetas-${a.codigo}.zpl`);
    });
  }
}

function coloresInfo(idColores, codigo, Descripcion, coloresInfo) {
  let ids = coloresInfo.map(function (e) {
    return e._id;
  });
  let coloresDany = Object.values(ids);

  setIdColoresArticulos(idColores);
  setCodigo(codigo);
  setDescripcion(Descripcion);
  setArrayColores(coloresDany);
  setColoresOriginales(coloresDany);
  toggleColores();
}

function coloresSeleccionados(checked, idColor) {
  setArrayColores((prev) =>
    checked ? (prev.includes(idColor) ? prev : [...prev, idColor]) : prev.filter((id) => id !== idColor)
  );
}

// Nombres de los que estaban asignados y se desmarcaron
function nombresQuitados(originales, actuales, catalogo) {
  return originales
    .filter((id) => !actuales.includes(id))
    .map((id) => (catalogo.find((c) => c._id === id) || {}).name || id);
}

function guardarColores() {
  const quitados = nombresQuitados(coloresOriginales, arrayColores, colores);
  if (quitados.length) {
    Swal.fire({
      title: "¿Quitar colores?",
      text: `Se quitarán del artículo: ${quitados.join(", ")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (r.isConfirmed) enviarColores();
    });
  } else {
    enviarColores();
  }
}

function enviarColores() {
  const URL_ARTICULOS_COLORES = `${process.env.REACT_APP_URL_ARTICULOS}/${idColoresArticulos}`;
  axios
    .patch(
      URL_ARTICULOS_COLORES,
      {
        colores: arrayColores,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Colores Articulo",
          detalle: `${codigo}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
      });
      console.log(error);
    });
}

function tallasInfo(idTallas, codigo, descripcion, tallasInfo) {
  let ids = tallasInfo.map(function (e) {
    return e._id;
  });
  let tallasDany = Object.values(ids);
  setIdTallasArticulos(idTallas);
  setCodigo(codigo);
  setDescripcion(descripcion);
  setArrayTallas(tallasDany);
  setTallasOriginales(tallasDany);
  toggleTallas();
}

function tallasSeleccionados(checked, idTalla) {
  setArrayTallas((prev) =>
    checked ? (prev.includes(idTalla) ? prev : [...prev, idTalla]) : prev.filter((id) => id !== idTalla)
  );
}

function guardarTallas() {
  const quitados = nombresQuitados(tallasOriginales, arrayTallas, tallas);
  if (quitados.length) {
    Swal.fire({
      title: "¿Quitar tallas?",
      text: `Se quitarán del artículo: ${quitados.join(", ")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (r.isConfirmed) enviarTallas();
    });
  } else {
    enviarTallas();
  }
}

function enviarTallas() {
  const URL_ARTICULOS_TALLAS = `${process.env.REACT_APP_URL_ARTICULOS}/${idTallasArticulos}`;
  axios
    .patch(
      URL_ARTICULOS_TALLAS,
      {
        tallas: arrayTallas,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Tallas Articulo",
          detalle: `${codigo}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
      });
      console.log(error);
    });
}


function catalogoProcesosInfo(idCatalogoProcesos, codigo, descripcion, catalogoProcesosInfo) {
  let ids = catalogoProcesosInfo.map(function (e) {
    return e._id;
  });
  let catalogoProcesosDany = Object.values(ids);

  setIdCatalogoProcesosArticulos(idCatalogoProcesos);
  setCodigo(codigo);
  setDescripcion(descripcion);
  setArrayCatalogoProcesos(catalogoProcesosDany);
  toggleCatalogoProcesos();
}

function catalogoProcesosSeleccionados(checked, idCatalogoProceso) {
  if (checked) {
    arrayCatalogoProcesos.push(idCatalogoProceso);
    console.log(arrayCatalogoProcesos);
  } else {
    const index = arrayCatalogoProcesos.indexOf(idCatalogoProceso);
    if (index > -1) {
      arrayCatalogoProcesos.splice(index, 1);
      console.log(arrayCatalogoProcesos);
    }
  }
}

function guardarCatalogoProcesos() {
  const URL_ARTICULOS_CATALOGO_PROCESOS = `${process.env.REACT_APP_URL_ARTICULOS}/${idCatalogoProcesosArticulos}`;
  axios
    .patch(
      URL_ARTICULOS_CATALOGO_PROCESOS,
      {
        catalogoProcesos: arrayCatalogoProcesos,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "CatalogoProcesos Articulo",
          detalle: `${codigo}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${(error.response && error.response.data && (error.response.data.message || (typeof error.response.data === "string" ? error.response.data : ""))) || ""}`,
      });
      console.log(error);
    });
}

function jalaFoto(
  idEdit
) {
  setPhoto("")
  const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
  axios
    .get(URL_GET_MEDIA, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((data) => {
      if (data.data.version) {
        setPhoto(data.data.version);
      }
    })
    .catch((err) => console.log(err));


  setIdEditArticulo(idEdit);
  toggleFoto();
}

// function importarArchivo(event) {
//   const target = event.target;
//   const value = target.type === "checkbox" ? target.checked : target.value;
//   const name = target.name;
//   let hojas = [];

//   if (name === "file") {
//     let reader = new FileReader();
//     reader.readAsArrayBuffer(target.files[0]);
//     reader.onloadend = (e) => {
//       var data = new Uint8Array(e.target.result);
//       var workbook = XLSX.read(data, { type: "array" });

//       workbook.SheetNames.forEach(function (sheetName) {
//         // Here is your object
//         var XL_row_object = XLSX.utils.sheet_to_json(
//           workbook.Sheets[sheetName]
//         );
//         hojas.push({
//           data: XL_row_object,
//           sheetName,
//         });
//       });

//       let A1 = hojas[0].data;

//       let TC = totalCaptura;
//       A1.map((a) => {
//         TC = TC + 1;
//         setTotalCaptura(TC);
//         inputFields.push({
//           id: uuidv4(),
//           fecha: "2023-07-05",
//           descripcion: a.descripcion,
//           compradores: "6488e1ecf6e88800149b9e88",
//           colaboradores: "62672cdfc3a7a03b8fec2bec",
//           marcas: a.marcas,
//           colecciones: a.colecciones,
//           colores: a.colores,
//           tallas: a.tallas,
//           catalogoProcesos: "6363fb596cdd150aab0461cd",
//           patronista: "63925f542134b10016b86764",
//           muestrista: "63925f542134b10016b86764",
//           ploter: "63925f542134b10016b86764",
//           clientes: a.clientes,
//           pedido: "NA",
//           codigo: a.codigo,
//           codigoCliente: a.codigoCliente,
//           departamentos: a.departamentos,
//           subDepartamentos: a.subDepartamentos,
//           clases: a.clases,
//           subClases: a.subClases,
//         });
//       });

//       let agrupado = inputFields.reduce(function (groups, item) {
//         const val = item["codigo"];
//         groups[val] = groups[val] || {
//           codigo: item.codigo,
//           colores: [],
//           tallas: [],
//         };
//         groups[val].colores.push(item.colores);
//         groups[val].tallas.push(item.tallas);
//         groups[val].fecha = item.fecha;
//         groups[val].descripcion = item.descripcion;
//         groups[val].compradores = item.compradores;
//         groups[val].colaboradores = item.colaboradores;
//         groups[val].marcas = item.marcas;
//         groups[val].colecciones = item.colecciones;
//         groups[val].catalogoProcesos = item.catalogoProcesos;
//         groups[val].patronista = item.patronista;
//         groups[val].muestrista = item.muestrista;
//         groups[val].ploter = item.ploter;
//         groups[val].clientes = item.clientes;
//         groups[val].pedido = item.pedido;
//         groups[val].codigo = item.codigo;
//         groups[val].codigoCliente = item.codigoCliente;
//         groups[val].departamentos = item.departamentos;
//         groups[val].subDepartamentos = item.subDepartamentos;
//         groups[val].clases = item.clases;
//         groups[val].subClases = item.subClases;
//         return groups;
//       }, []);

//       let agrupadoValues = Object.values(agrupado);

//       let agrupadoColores = agrupadoValues.map((a)=>{
//         if(a.descripcion != ""){
//         return{
//             descripcion: a.descripcion,
//             compradores: a.compradores,
//             colaboradores: a.colaboradores,
//             marcas: a.marcas,
//             colecciones: a.colecciones,
//             colores: a.colores.filter((item,index)=>{
//               return a.colores.indexOf(item) === index;
//             }),
//             tallas: a.tallas.filter((item,index)=>{
//               return a.tallas.indexOf(item) === index;
//             }),
//             catalogoProcesos: a.catalogoProcesos,
//             patronista: a.patronista,
//             muestrista: a.muestrista,
//             ploter: a.ploter,
//             clientes: a.clientes,
//             codigo: a.codigo,
//             codigoCliente: a.codigoCliente,
//             departamentos: a.departamentos,
//             subDepartamentos: a.subDepartamentos,
//             clases: a.clases,
//             subClases: a.subClases,
//         }
//       }
//       })
//       .filter(function (el) {
//         return el != null;
//       });

//       console.log("hola2", agrupadoColores);

//       agrupadoColores.map(async(a)=>{
//         if(a.fecha != ""){
//         await axios
//         .post(
//           URL_ARTICULOS,
//           {
//             fecha: "2023-07-11",
//             descripcion: a.descripcion,
//             compradores: a.compradores,
//             colaboradores: a.colaboradores,
//             marcas: a.marcas,
//             colecciones: a.colecciones,
//             colores: a.colores,
//             tallas: a.tallas,
//             catalogoProcesos: a.catalogoProcesos,
//             patronista: a.patronista,
//             muestrista: a.muestrista,
//             ploter: a.ploter,
//             clientes: a.clientes,
//             pedido: "NA",
//             codigo: a.codigo.toString(),
//             codigoCliente: a.codigoCliente.toString(),
//             departamentos: a.departamentos,
//             subDepartamentos: a.subDepartamentos,
//             clases: a.clases,
//             subClases: a.subClases,
//           },
//           {
//             headers: {
//               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//             },
//           }
//         )
//         .then(() => {
//           Swal.fire("Good job!", "Creado con exito", "success");
//         })
//         .catch((error) => {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: "Something went wrong!",
//             footer: `${error.response.data}`,
//           });
//           console.log(error);
//           setValidaBoton(true);
//         })
//         }


//       })

//     };
//   }
// }


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.articulos_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ArticulosCreateSolo"
                >
                  Nuevo Modelo
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Modelo
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              {/* <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>
                Enviar Modelos
              </h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-tshirt" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Modelos
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Coleccion</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedColeccion}
                onChange={(e) => {
                  setSelectedColeccion(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {colecciones
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </div>
            <div>
              <Label>Departamento</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedDepartamento}
                onChange={(e) => {
                  setSelectedDepartamento(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {departamentos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </div>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.is_active}</td>
                      <td>{a.codigo}</td>
                      <td>{a.codigoCliente}</td>
                      <td>{a.descripcion}</td>
                      {/* <td>{a.marca} </td> */}
                      <td>{a.coleccion} </td>
                      <td>{a.departamento}</td>
                        <>
                          {/* Especificación: colores, tallas, QR */}
                          <td>
                            <Button
                              color="success"
                              id="Colores"
                              size="sm"
                              onClick={(e) =>
                                coloresInfo(
                                  a._id,
                                  a.codigo,
                                  a.descripcion,
                                  a.colores
                                )
                              }
                            >
                              <i class="fas fa-palette"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Tallas"
                              size="sm"
                              onClick={(e) =>
                                tallasInfo(
                                  a._id,
                                  a.codigo,
                                  a.descripcion,
                                  a.tallas
                                )
                              }
                            >
                              <i class="fas fa-ruler-horizontal"></i>
                            </Button>
                            <Button
                              color="dark"
                              id="QR"
                              size="sm"
                              title="Generar etiquetas QR por color y talla"
                              onClick={(e) => abrirEtiquetas(a)}
                            >
                              <i class="fas fa-qrcode"></i>
                            </Button>
                          </td>
                          {/* Diseño: explosión de telas, procesos */}
                          <td>
                            <Button
                              color="success"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                explosion(
                                  a._id,
                                  a.codigo,
                                  a.descripcion
                                )
                              }
                            >
                              <i class="fas fa-tag"></i>
                            </Button>
                            <Button
                              color="danger"
                              id="CatalogoProcesos"
                              size="sm"
                              onClick={(e) =>
                                catalogoProcesosInfo(
                                  a._id,
                                  a.codigo,
                                  a.descripcion,
                                  a.catalogoProcesos
                                )
                              }
                            >
                              <i class="fas fa-tshirt"></i>
                            </Button>
                          </td>
                          {/* Acciones: editar, foto, baja */}
                          <td>
                            <Button
                              hidden={!user.articulos_editar}
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.codigo,
                                  a.codigoCliente,
                                  a.codigoSAT,
                                  a.codigoUnidad,
                                  a.descripcion,
                                  a.observaciones,
                                  // a.idMarca,
                                  a.idColeccion,
                                  a._id,
                                  a.idMuestrista,
                                  a.idPatronista,
                                  a.idPloter,
                                  a.precioA,
                                  a.precioB,
                                  a.precioC,
                                  a.precioD,
                                  a.precioE,
                                  a.precioF,
                                  a.precioG,
                                  a.precioH,
                                  a.precioI,
                                  a.precioJ,
                                  a.idDepartamento,
                                  a.piezasPrenda
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaFoto(
                                  a._id
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                            {user.articulos_editar ? (
                              <Baja
                                idStatus={a._id}
                                is_active={a.is_active}
                                URL_BAJA={process.env.REACT_APP_URL_ARTICULOS}
                              />
                            ) : undefined}
                          </td>
                        </>
                    
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            <i className="fas fa-edit" style={{ marginRight: 8, color: "#8b5cf6" }} />
            Editar Modelo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-tshirt" />
              <span className="form-section-title">Datos del Modelo</span>
            </div>
            <div className="form-section-body">
        <Row>
              <Col md={3}>
                <Label>Codigo</Label>
                <Input
                  type="text"
                  placeholder="Codigo"
                  value={codigo}
                  required
                  onChange={(e) => {
                    setCodigo(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Codigo Cliente</Label>
                <Input
                  type="text"
                  placeholder="CodigoCliente"
                  value={codigoCliente}
                  required
                  onChange={(e) => {
                    setCodigoCliente(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Piezas por prenda</Label>
                <Input
                  type="number"
                  min="1"
                  step="1"
                  title="Conjunto de 2 piezas = 2. Las etiquetas QR se imprimen una por pieza."
                  value={piezasPrenda}
                  onChange={(e) => setPiezasPrenda(e.target.value)}
                />
              </Col>
              
              <Col md={3}>
                <Label className="mr-sm-2">Coleccion</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedColeccionEdit}
                  required
                  onChange={(e) => {
                    setSelectedColeccionEdit(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>

              <Col md={3}>
                <Label className="mr-sm-2">Departamento</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedDepartamentoEdit}
                  onChange={(e) => {
                    setSelectedDepartamentoEdit(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {departamentos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>

              </Row>
              <Row>
              <Col md={6}>
                <Label>Descripcion</Label>
                <Input
                  type="text"
                  placeholder="Descripcion"
                  value={descripcion}
                  required
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                />
              </Col>
              </Row>
            <Row>
              <Col md={2}>
                <Label>Precio A</Label>
                <Input type="number" value={precioA} onChange={(e) => setPrecioA(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio B</Label>
                <Input type="number" value={precioB} onChange={(e) => setPrecioB(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio C</Label>
                <Input type="number" value={precioC} onChange={(e) => setPrecioC(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio D</Label>
                <Input type="number" value={precioD} onChange={(e) => setPrecioD(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio E</Label>
                <Input type="number" value={precioE} onChange={(e) => setPrecioE(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio F</Label>
                <Input type="number" value={precioF} onChange={(e) => setPrecioF(e.target.value)} />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label>Precio G</Label>
                <Input type="number" value={precioG} onChange={(e) => setPrecioG(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio H</Label>
                <Input type="number" value={precioH} onChange={(e) => setPrecioH(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio I</Label>
                <Input type="number" value={precioI} onChange={(e) => setPrecioI(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Precio J</Label>
                <Input type="number" value={precioJ} onChange={(e) => setPrecioJ(e.target.value)} />
              </Col>
            </Row>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-image" />
              <span className="form-section-title">Foto</span>
            </div>
            <div className="form-section-body">
              <Row>
              <Col md={6}>
              <Label>
                Foto
              </Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>
            Explosion Modelo {codigoExplosion} / {descripcionExplosion}
          </h4>
        </ModalHeader>
        <ModalBody>

          <Row>
            <Col md={6}>
            <Label>Tela</Label>
            </Col>
            <Col md={3}>
            <Label>Cantidad</Label>
            </Col>
          </Row>
          {explosionExistentes.map((a)=>(
            a.tipo=="Tela"?(
            <div key={a._id}>
              <Row>
              <Col md={6}>
                      <Input
                        bsSize="sm"
                        name="telas"
                        type="select"
                        value={a.telas[0]._id}
                        required
                        disabled
                      >
                        <option value="">Selecciona</option>
                        {telas
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.codigo} / {a.nombre}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={3}>
                        <Input
                         bsSize="sm"
                          name="cantidad"
                          type="number"
                          value={a.cantidad}
                          onChange={(event)=>{handleChangeInputExistente(a._id, event)}}
                        >
                        </Input>
                      </Col>
              </Row>
            </div>):undefined
          ))}
             {inputFieldsTela.map((a)=>(
            <div key={a.id}>
              <Row>
              <Col md={6}>
                      <Input
                        bsSize="sm"
                        name="idTela"
                        type="select"
                        value={a.idTela}
                        required
                        onChange={(event)=>{handleChangeInputTela(a.id, event)}}
                      >
                        <option value="">Selecciona</option>
                        {telas
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.codigo} / {a.nombre}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={3}>
                        <Input
                         bsSize="sm"
                          name="cantidad"
                          type="number"
                          value={a.cantidad}
                          onChange={(event)=>{handleChangeInputTela(a.id, event)}}
                        >
                        </Input>
                      </Col>
                      <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsTela.length === 1}
                        onClick={() => handleRemoveFieldsTelas(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsTelas}
                      tabindex="-1">
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
              </Row>
            </div>
          ))}
    <br/>
        <Row>
            <Col md={6}>
            <Label>Habilitacion</Label>
            </Col>
            <Col md={3}>
            <Label>Cantidad</Label>
            </Col>
          </Row>
          {explosionExistentes.map((a)=>(
            a.tipo=="Habilitacion"?(
            <div key={a._id}>
              <Row>
              <Col md={6}>
                      <Input
                        bsSize="sm"
                        name="habilitacion"
                        type="select"
                        value={a.habilitacion[0]._id}
                        required
                        disabled
                      >
                        <option value="">Selecciona</option>
                        {habilitacion
                          .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                 {a.descripcion} {a.nombre} 
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={3}>
                        <Input
                         bsSize="sm"
                          name="cantidad"
                          type="number"
                          value={a.cantidad}
                          onChange={(event)=>{handleChangeInputExistente(a._id, event)}}
                        >
                        </Input>
                      </Col>
              </Row>
            </div>):undefined
          ))}
          {inputFieldsHab.map((a)=>(
            <div key={a.id}>
              <Row>
              <Col md={6}>
                      <Input
                        bsSize="sm"
                        name="idHab"
                        type="select"
                        value={a.idHab}
                        required
                        onChange={(event)=>{handleChangeInputHab(a.id, event)}}
                      >
                        <option value="">Selecciona</option>
                        {habilitacion
                          .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                 {a.descripcion} {a.nombre} 
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={3}>
                        <Input
                         bsSize="sm"
                          name="cantidad"
                          type="number"
                          value={a.cantidad}
                          onChange={(event)=>{handleChangeInputHab(a.id, event)}}
                        >
                        </Input>
                      </Col>
                      <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsHab.length === 1}
                        onClick={() => handleRemoveFieldsHab(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHab}
                      tabindex="-1">
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
              </Row>
            </div>
          ))}
      </ModalBody>
        <ModalFooter>
        {validaBoton ? (
              <Button type="submit" className="btn btn-success" onClick={saveExplosion}>
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
        <ModalHeader toggle={toggleColores}>
          <h4>
            Colores del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 12, color: "#6c757d" }}>
            Marcados = asignados al artículo. Desmarca para quitar (solo si no tiene inventario en ese color).
          </p>
          {[...colores]
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a) => (
              <table key={a._id}>
                <td>
                  <Input
                    type="checkbox"
                    checked={arrayColores.includes(a._id)}
                    onChange={(e) => {
                      coloresSeleccionados(e.currentTarget.checked, a._id);
                    }}
                    className="subMenu"
                  />
                  <h5
                    className="subMenuTitulo"
                    style={coloresOriginales.includes(a._id) ? { fontWeight: 700 } : undefined}
                  >
                    {a.name}
                  </h5>
                </td>
              </table>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarColores}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
        <ModalHeader toggle={toggleTallas}>
          <h4>
            Tallas del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 12, color: "#6c757d" }}>
            Marcadas = asignadas al artículo. Desmarca para quitar (solo si no tiene inventario en esa talla).
          </p>
          {[...tallas]
            .sort((a, b) => compararTallas(a.name, b.name))
            .map((a) => (
              <table key={a._id}>
                <td>
                  <Input
                    type="checkbox"
                    checked={arrayTallas.includes(a._id)}
                    onChange={(e) => {
                      tallasSeleccionados(e.currentTarget.checked, a._id);
                    }}
                    className="subMenu"
                  />
                  <h5
                    className="subMenuTitulo"
                    style={tallasOriginales.includes(a._id) ? { fontWeight: 700 } : undefined}
                  >
                    {a.name}
                  </h5>
                </td>
              </table>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarTallas}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal: cantidad de etiquetas por color y talla */}
      <Modal size="lg" isOpen={modalEtiquetas} toggle={toggleEtiquetas}>
        <ModalHeader toggle={toggleEtiquetas}>
          <h4>
            Etiquetas QR{etiquetaArticulo ? ` — ${etiquetaArticulo.codigo}` : ""}
          </h4>
        </ModalHeader>
        <ModalBody>
          <p className="text-muted" style={{ fontSize: "0.85rem" }}>
            Selecciona color y talla. <b>Generar etiqueta</b> = PDF de una (vista
            previa). <b>Imprimir en Zebra</b> = manda la cantidad indicada a la
            GT800 (3 por renglón).
          </p>
          <Row>
            <Col md={4}>
              <Label>Color</Label>
              <Input
                type="select"
                value={etiquetaColor}
                onChange={(e) => setEtiquetaColor(e.target.value)}
              >
                {colores.map((c) => (
                  <option key={c._id} value={c.name}>
                    {c.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Talla</Label>
              <Input
                type="select"
                value={etiquetaTalla}
                onChange={(e) => setEtiquetaTalla(e.target.value)}
              >
                {tallas.map((t) => (
                  <option key={t._id} value={t.name}>
                    {t.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Prendas (Zebra)</Label>
              <Input
                type="number"
                min="1"
                value={etiquetaCantidad}
                onChange={(e) => setEtiquetaCantidad(e.target.value)}
              />
              {piezasDe(etiquetaArticulo) > 1 ? (
                <small style={{ color: "#b45309" }}>
                  Prenda de {piezasDe(etiquetaArticulo)} piezas: salen{" "}
                  {(parseInt(etiquetaCantidad, 10) || 0) * piezasDe(etiquetaArticulo)} etiquetas
                </small>
              ) : null}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEtiquetas}>
            Cancelar
          </Button>
          <Button color="dark" onClick={generarEtiquetas}>
            <i className="fas fa-qrcode" /> Generar etiqueta (PDF)
          </Button>
          <Button color="primary" onClick={imprimirEtiquetasZebra}>
            <i className="fas fa-print" /> Imprimir en Zebra
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalCatalogoProcesos} toggle={toggleCatalogoProcesos}>
        <ModalHeader toggle={toggleCatalogoProcesos}>
          <h4>
            Procesos del Articulo {codigo} / {descripcion}
          </h4>
        </ModalHeader>
        <ModalBody>
          {catalogoProcesos
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a, index) => {
              if (!arrayCatalogoProcesos.includes(a._id)) {
                return (
                  <table>
                    <td>
                      <Input
                        type="checkbox"
                        key={index}
                        onChange={(e) => {
                          catalogoProcesosSeleccionados(e.currentTarget.checked, a._id);
                        }}
                        className="subMenu"
                      />
                      <h5 className="subMenuTitulo">{a.name}</h5>
                    </td>
                  </table>
                );
              } else {
                return <h5 className="subMenuTitulo">{a.name}</h5>;
              }
            })}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarCatalogoProcesos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Ficha Tecnica
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/gaviniArticulos/${idEditArticulo}`}
                  alt=""
                />
              </h6>
            ) : <h4>No se ha subido una Ficha Tecnica....</h4>}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios minutos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

      {loader}
    </>
  );
}

export default ListadoArticulos;
